import axios from 'axios'

export default axios.create({
    baseURL: 'http://173.249.12.146:8091/api'
})

// export default axios.create({
//     baseURL: 'http://173.249.12.146:8091/api' prod
//     baseURL: 'http://173.249.12.146:8081/api' test
// baseURL: 'http://localhost:5000/api'
// })
